import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_ARROW_UP_DOWN: GlameraIconDefinition = {
  name: 'arrow-up-down',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-arrow-up-down-down">
      <path d="m21 16-4 4-4-4"></path>
      <path d="M17 20V4"></path>
    </g>
    <g class="glm-arrow-up-down-up">
      <path d="m3 8 4-4 4 4"></path>
      <path d="M7 4v16"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-arrow-up-down-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './arrow-up-down.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ArrowUpDownIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_ARROW_UP_DOWN;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
